var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/StatusPanel/StatusPanel.tsx";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import React from 'react';
import { useStore } from 'effector-react';
import { Tooltip } from '@gmini/ui-kit';
import { combine, createStore } from 'effector';
import { buildKeyByPath } from "../ClassifierTree/utils";
import { StatusPanelLayout } from "../StatusPanelLayout";
import { changeViewerMode, showInViewerMode$, viewerShowModeDescription } from "../../forge-viewer/model/selectModel";
import { goals } from "../../metrika";
import { SelectedCounter, CrossCircle, SelectItem, ArrowDown, SelectButton, Popover, StatusPanelHeader, OpenSourcePanelIcon, OpenSourcePanelButton } from "./StatusPanel.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function createStatusPanel(_ref) {
  var flatTree$ = _ref.flatTree$,
      checkedModel = _ref.checkedModel,
      SelectSourcePanel = _ref.SelectSourcePanel,
      searchNodesInfo$ = _ref.searchNodesInfo$,
      _ref$hideIsolateButto = _ref.hideIsolateButton$,
      hideIsolateButton$ = _ref$hideIsolateButto === void 0 ? createStore(false, {
    ɔ: {
      ɔ: {
        name: "hideIsolateButton$",
        sid: "ked9v0"
      },
      name: "hideIsolateButton$",
      sid: "ked9v0"
    },
    name: "hideIsolateButton$",
    sid: "ked9v0"
  }) : _ref$hideIsolateButto,
      openedFilterPanel$ = _ref.openedFilterPanel$,
      _ref$selectedSourceNo = _ref.selectedSourceNodes$,
      selectedSourceNodes$ = _ref$selectedSourceNo === void 0 ? createStore([], {
    ɔ: {
      ɔ: {
        name: "selectedSourceNodes$",
        sid: "-f5qbg8"
      },
      name: "selectedSourceNodes$",
      sid: "-f5qbg8"
    },
    name: "selectedSourceNodes$",
    sid: "-f5qbg8"
  }) : _ref$selectedSourceNo;
  var checkedList$ = combine({
    ɔ: [{
      tree: flatTree$,
      checked: checkedModel.checked$
    }, function (_ref2) {
      var checked = _ref2.checked,
          tree = _ref2.tree;
      var keys = Object.keys(checked);
      return tree.filter(function (item) {
        return keys.some(function (k) {
          return buildKeyByPath(item.path) === k;
        });
      }).map(function (_ref3) {
        var ref = _ref3.ref;
        return ref;
      });
    }],
    config: {
      name: "checkedList$",
      sid: "u5hh9d"
    }
  });
  var StatusPanel = /*#__PURE__*/React.memo(function (_ref4) {
    var _searchNodesInfo$node2, _searchNodesInfo$node3;

    var content = _ref4.content;
    var openedFilterPanel = useStore(openedFilterPanel$, {
      loc: {
        file: _effectorFileName,
        line: 86,
        column: 30
      },
      name: "StatusPanel",
      sid: "StatusPanel /src/classifier-editor/StatusPanel/StatusPanel.tsx [86, 30]"
    });
    var hideIsolateButton = useStore(hideIsolateButton$, {
      loc: {
        file: _effectorFileName,
        line: 87,
        column: 30
      },
      name: "StatusPanel",
      sid: "StatusPanel /src/classifier-editor/StatusPanel/StatusPanel.tsx [87, 30]"
    });
    var selectedSourceNodes = useStore(selectedSourceNodes$, {
      loc: {
        file: _effectorFileName,
        line: 88,
        column: 32
      },
      name: "StatusPanel",
      sid: "StatusPanel /src/classifier-editor/StatusPanel/StatusPanel.tsx [88, 32]"
    });

    var _React$useState = React.useState(false),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        openedSourcePanel = _React$useState2[0],
        setOpenedSourcePanel = _React$useState2[1];

    var checkedList = useStore(checkedList$, {
      loc: {
        file: _effectorFileName,
        line: 90,
        column: 24
      },
      name: "StatusPanel",
      sid: "StatusPanel /src/classifier-editor/StatusPanel/StatusPanel.tsx [90, 24]"
    });
    var checkedCount = checkedList.length;
    var searchNodesInfo = useStore(searchNodesInfo$, {
      loc: {
        file: _effectorFileName,
        line: 93,
        column: 28
      },
      name: "StatusPanel",
      sid: "StatusPanel /src/classifier-editor/StatusPanel/StatusPanel.tsx [93, 28]"
    });
    var viewerShowMode = useStore(showInViewerMode$, {
      loc: {
        file: _effectorFileName,
        line: 95,
        column: 27
      },
      name: "StatusPanel",
      sid: "StatusPanel /src/classifier-editor/StatusPanel/StatusPanel.tsx [95, 27]"
    });

    var _React$useState3 = React.useState(null),
        _React$useState4 = _slicedToArray(_React$useState3, 2),
        anchorEl = _React$useState4[0],
        setAnchorEl = _React$useState4[1];

    var resetCheckedModel = React.useCallback(function () {
      checkedModel.resetChecked();
    }, []);
    var changeModeInViewer = React.useCallback(function (value) {
      switch (value) {
        case 'Hide':
          goals.selectViewerModeHideUnchosen();
          break;

        case 'Isolate':
          goals.selectViewerModeTransparent();
          break;

        case 'ShowAll':
          goals.selectViewerModeAll();
          break;
      }

      return changeViewerMode(value);
    }, []);

    if (!checkedCount && content) {
      return /*#__PURE__*/_jsx(StatusPanelLayout, {
        open: true,
        children: content
      });
    }

    var displayShowInViewer = checkedList.some(function (selected) {
      return selected.type !== 'UserClassifierEmptyGroupNode';
    });

    var handleClick = function handleClick(event) {
      var _searchNodesInfo$node;

      if (searchNodesInfo !== null && searchNodesInfo !== void 0 && (_searchNodesInfo$node = searchNodesInfo.nodes) !== null && _searchNodesInfo$node !== void 0 && _searchNodesInfo$node.length) {
        return;
      }

      setAnchorEl(event.currentTarget);
    };

    var handleClose = function handleClose() {
      setAnchorEl(null);
    };

    var open = Boolean(anchorEl);
    var id = open ? 'status-popover' : undefined;
    var haveSelectedSourceNodes = SelectSourcePanel && Boolean(selectedSourceNodes.length);
    return /*#__PURE__*/_jsxs(StatusPanelLayout, {
      open: Boolean(checkedCount),
      isDirectionCol: hideIsolateButton,
      children: [/*#__PURE__*/_jsxs(StatusPanelHeader, {
        children: [/*#__PURE__*/_jsxs(SelectedCounter, {
          children: ["\u0412\u044B\u0431\u0440\u0430\u043D\u043E ", checkedCount, /*#__PURE__*/_jsx(CrossCircle, {
            onClick: resetCheckedModel
          })]
        }), hideIsolateButton ? null : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Popover, {
            open: open,
            anchorEl: anchorEl,
            id: id,
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'right'
            },
            transformOrigin: {
              vertical: 'bottom',
              horizontal: 'right'
            },
            onClose: handleClose,
            children: Object.keys(viewerShowModeDescription).map(function (key) {
              return /*#__PURE__*/_jsx(SelectItem, {
                onClick: function onClick() {
                  return changeModeInViewer(key);
                },
                active: viewerShowMode === key,
                children: viewerShowModeDescription[key]
              }, key);
            })
          }), displayShowInViewer && /*#__PURE__*/_jsx(Tooltip, {
            title: searchNodesInfo !== null && searchNodesInfo !== void 0 && (_searchNodesInfo$node2 = searchNodesInfo.nodes) !== null && _searchNodesInfo$node2 !== void 0 && _searchNodesInfo$node2.length ? 'Сначала нужно выключить режим "Найти везде"' : '',
            children: /*#__PURE__*/_jsxs(SelectButton, {
              active: open,
              onClick: handleClick,
              disabled: !!(searchNodesInfo !== null && searchNodesInfo !== void 0 && (_searchNodesInfo$node3 = searchNodesInfo.nodes) !== null && _searchNodesInfo$node3 !== void 0 && _searchNodesInfo$node3.length),
              children: [viewerShowModeDescription[viewerShowMode], /*#__PURE__*/_jsx(ArrowDown, {})]
            })
          })]
        }), haveSelectedSourceNodes && openedFilterPanel.open && /*#__PURE__*/_jsx(OpenSourcePanelButton, {
          onClick: function onClick() {
            return setOpenedSourcePanel(function (prev) {
              return !prev;
            });
          },
          type: "circle",
          children: /*#__PURE__*/_jsx(OpenSourcePanelIcon, {
            opened: openedSourcePanel
          })
        })]
      }), haveSelectedSourceNodes && openedSourcePanel ? /*#__PURE__*/_jsx(SelectSourcePanel, {}) : null]
    });
  });
  StatusPanel.displayName = 'StatusPanel';
  return {
    StatusPanel: StatusPanel
  };
}